require('./bootstrap');

$('.navbar-toggler').on('click', function () {
  $(this).toggleClass('is-active');
  $('.navbar-collapse.show[id]').each(function () {
    $('.navbar-toggler.is-active[data-target="#' + $(this).attr('id') + '"]').click();
  });
});

$('.btn-subscribe').on('click', function (e) {
  e.preventDefault();

  let subscribe = true;
  this.name = $('#newsletter-subscribe #name').val();
  this.email = $('#newsletter-subscribe #email').val();
  this.terms = $('#newsletter-subscribe #terms').is(':checked');

  if (!this.name) {
    $('.name.error-message').html('Kérjük töltsd ki a neved.');
    subscribe = false;
  } else {
    $('.name.error-message').html('');
    subscribe = true;
  }

  if (!this.email) {
    $('.email.error-message').html('Kérjük töltsd ki az e-mail címed.');
    subscribe = false;
  } else {
    $('.email.error-message').html('');
    subscribe = true;
  }

  if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email) != true) {
    $('.email.error-message').html('Kérjük érvényes e-mail címet adj meg.');
    subscribe = false;
  }

  if (!this.terms) {
    $('.terms.error-message').html('Kérjük fogadd el a szabályzatot.');
    subscribe = false;
  } else {
    $('.terms.error-message').html('');
    subscribe = true;
  }

  if (!subscribe) return false;

  $.ajax({
    type: 'POST',
    url: '/hirlevel-feliratkozas',
    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
    data: {
      name: this.name,
      email: this.email,
      terms: this.terms,
    },
  }).then((response) => {
    if (response.error) {
      $('.response-status').html('A hírlevél feliratkozás sikertelen. Kérjük később próbáld meg újra.').addClass('p-3');
    } else {
      location.href = '/hirlevel/sikeres-feliratkozas';
    }
  });
});

$(document).ready(function () {
  //Recipe search
  $("#recipe-search-form").on('change', function () {
    $('#recipe-search-form').trigger('submit');
  });

  //About us
  $(".korostejkft").on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#korostejkft").offset().top - 300
    });
  });
  $(".hajdusuperbrand").on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#hajdusuperbrand").offset().top - 300
    });
  });

  $(".btn-scroll").on('click', function (e) {
    e.preventDefault();

    var targetId = $(this).data('target');
    scrollToTarget(targetId);
  });

  $('.avatar').on('click', function () {
    var index = $('.avatar').index(this);
    $('#favorite').prop('selectedIndex', index + 1);
    scrollToTarget('szavazas')
  });
  $('.product').on('click', function () {
    var index = $('.product').index(this);
    $('#favorite').prop('selectedIndex', index + 1);
    scrollToTarget('szavazas')
  });
  $('#game-form').on('submit', function (e) {
    e.preventDefault();

    var formElement = $(this);
    var submitButton = $('.btn-submit');
    var formData = $(this).serialize();
    var errorContainer = $('#szavazas');

    submitButton.html('<i class="fas fa-spinner fa-spin"></i> Kérlek várj...');

    $.ajax({
      url: $(this).data('route'),
      type: "POST",
      data: formData,
      success: function (response) {
        console.log(response);
        formElement.fadeOut(100, function () {
          formElement.replaceWith(response);
          $('.thank-you').fadeIn(100);
        });
      },
      error: function (response) {
        var errors = response.responseJSON.errors;

        $('.error-message').empty();

        $.each(errors, function (field, messages) {
          var errorMessage = messages[0];
          $('.' + field + 'ErrorMsg').text(errorMessage);
        });
      },
      complete: function () {
        // Remove the loading spinner from the button
        submitButton.html('Szavazat beküldése');

        // Scroll to the top of the first error element
        if (errorContainer.children().length === 1) {
          var firstErrorElement = $('.error-message').first();
          var firstErrorElementOffset = firstErrorElement.offset().top;

          var scrollPosition = firstErrorElementOffset - 150;

          $('html, body').animate({
            scrollTop: scrollPosition
          }, 600);

        }
      }
    });
  });

});

function scrollToTarget(targetId) {
  var targetElement = document.getElementById(targetId);

  if (targetElement) {
    var targetOffset = $(targetElement).offset().top;
    var offsetTop = targetOffset - 120;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  }
}